<template>
  <div>
    <a-tag color="red" v-if="[AnnounceState.APPROVAL, AnnounceState.SAVE].includes(state)">未发布</a-tag>
    <a-tag color="green" v-if="AnnounceState.PUBLISH===state">已发布</a-tag>
    <a-tag color="red" v-if="AnnounceState.REVOCATION===state">已撤回</a-tag>
  </div>
</template>
<script>

import {AnnounceState} from "@/views/bid/announce/util/AnnounceUtil";

export default {
  name: 'AnnounceMark',
  computed: {},
  components: {},
  props: {
    state: {
      type: String,
      default: undefined
    }
  },
  created() {
  },
  data() {
    return {
      AnnounceState
    }
  },
  methods: {}
}
</script>

<style scoped>

</style>

